var LayoutPerspective = require('./../layout/LayoutPerspective');
var appointmentBillPerspectiveTemplate = require('./appointmentBillPerspectiveTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var AppointmentBillView = require('./AppointmentBillView');
var WizardAccessBehavior = require('./../wizard/WizardAccessBehavior');
var WizardPerspectiveBehavior = require('./../wizard/WizardPerspectiveBehavior');

/**
* Perspective to display the Appointment Bill page
* This is for the current Patient Portal (not needed in Design Demo)
*
* @param options {Object} Options to configure this perspective.
*   @param [options.patientVecnaId] {String} the vecna id of the current patient
*   @param [options.appointmentExternalId] {String} the external id of the current appointment
*/
module.exports = LayoutPerspective.extend({
  template: appointmentBillPerspectiveTemplate,
  moduleNamespace: 'appointmentBillPerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: PortalPerspectiveLayoutBehavior,
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'appointment.bill.aside.header',
      asideContentMessageKey: 'appointment.bill.aside'
    },
    wizardAccessBehavior: WizardAccessBehavior,
    wizardPerspectiveBehavior: {
      behavior: WizardPerspectiveBehavior,
      pageName: WizardPerspectiveBehavior.PAGE_NAMES.PAYMENT,
      childPageName: WizardPerspectiveBehavior.PAGE_NAMES.BILL_DETAIL
    }
  },

  injectionSites: {
    'appointment-bill-view': '_appointmentBillView'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date of the current appointments being preregistered for
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    // These are set for the wizard behaviors.
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    this._appointmentBillView = new AppointmentBillView({
      className: 'page-content',
      appointmentExternalId: options.appointmentExternalId,
      patientVecnaId: options.patientVecnaId,
      regDate: options.regDate
    });
  }
});
